import React, { Component } from 'react'
import { ChangeHistoryDetailModel } from "./models/change.history.detail.model";
import { Editor } from "../../../../shared";
import { DETAIL_KEYS, STYLE_LABEL_MAP } from "./constants/labels"

interface DescriptionProps {
  result: ChangeHistoryDetailModel;
}
export class DashboardChangeHistoryDescription extends Component<DescriptionProps> {

  formatParsedSettings(settings: any) {
  if (!settings) return settings;

  const formatted = { ...settings };

  const styleValue = formatted[":style"];
  if (styleValue && STYLE_LABEL_MAP[styleValue]) {
    formatted[":style"] = `${STYLE_LABEL_MAP[styleValue]}`;
  }

  return formatted;
}
  buildWidgetUpdate(result: ChangeHistoryDetailModel): string {
    const details: string[] = [
      `${DETAIL_KEYS.WIDGET_ID}: ${result.item_id}`,
      `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
      `${DETAIL_KEYS.EVENT}: ${result.event}`,
    ];

    if (result.object_changes?.order?.length === 2) {
      details.push(
      `${DETAIL_KEYS.ORDER}:`,
      `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.object_changes.order[0], null, '\t')}`,
      `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.object_changes.order[1], null, '\t')}`
    );
    }
    if (result.object_changes?.name?.length === 2) {
      details.push(`${DETAIL_KEYS.NAME}:`,
      `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.object_changes.name[0], null, '\t')}`,
      `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.object_changes.name[1], null, '\t')}`)
    }
    if (result.object_changes?.settings?.length === 2) {
      details.push(`${DETAIL_KEYS.SETTINGS}:`,
      `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(this.formatParsedSettings(result.parsed_object_settings), null, '\t')}`,
      `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(this.formatParsedSettings(result.parsed_changes_settings), null, '\t')}`)
    }
    if (result.object_changes?.custom_settings?.length === 2) {
      details.push(`${DETAIL_KEYS.CUSTOM_SETTING}:`,
      `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(this.formatParsedSettings(result.parsed_object_custom_settings), null, '\t')}`,
      `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(this.formatParsedSettings(result.parsed_changes_custom_settings), null, '\t')}`)
    }

    return details.join("\n");
  }
  render() {
    const { result } = this.props;
    if (!result) return null;

    let descriptionText = `Dashboard Changes:\n-----------------------\n`;


    switch (`${result.item_type}_${result.event}`) {
      case "DashboardShare_create": {
        let details = [
          `${DETAIL_KEYS.DASHBAORD_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${result.event}`,
          `${DETAIL_KEYS.SHARED_TO}: ${result.object_changes?.user_id?.[1]}`,
          `${DETAIL_KEYS.TYPE_ROLE}: ${result.object_changes?.role?.[1]}`,
        ];
        descriptionText += details.join("\n");
        break;
      }
      case "DashboardShare_update": {
        let details = [
          `${DETAIL_KEYS.DASHBAORD_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${result.event}`,
        ];
         if (result.object_changes?.custom_settings?.length === 2) {
          details.push(
          `${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.parsed_object_custom_settings, null, '\t')}`,
          `${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.parsed_changes_custom_settings, null, '\t')}`)
        }
        if (result.object_changes?.role?.length === 2) {
          details.push(`${DETAIL_KEYS.ROLE}:`,
          `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.object_changes?.role?.[0], null, '\t')}`,
          `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.object_changes?.role?.[1], null, '\t')}`)
        }


        descriptionText += details.join("\n");
        break;
      }
      case "DashboardShare_destroy": {
        let details = [
          `${DETAIL_KEYS.DASHBAORD_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${DETAIL_KEYS.UNSHARED}`,
          `${DETAIL_KEYS.UNSHARED_WITH}: ${result.object_changes?.user_id?.[0]}`,
          `${DETAIL_KEYS.TYPE_ROLE}: ${result.object_changes?.role?.[0]}`,
        ];
        descriptionText += details.join("\n");
        break;
      }
      case "Widget_create": {

        let details = [
          `${DETAIL_KEYS.WIDGET_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${result.event}`,
        ];

        if (result.object_changes?.name?.length === 2) {
          details.push(`${DETAIL_KEYS.NAME}: ${JSON.stringify(result.object_changes.name[1], null, '\t')}`)
        }
        if (result.object_changes?.settings?.length === 2) {
          details.push(`${DETAIL_KEYS.SETTINGS}: ${JSON.stringify(this.formatParsedSettings(result.parsed_changes_settings), null, '\t')}`)
        }
        descriptionText += details.join("\n");
        break;
      }
      case "Widget_update": {
        descriptionText += this.buildWidgetUpdate(result);
        break;
      }
      case "Widget_destroy": {
        let details = [
          `${DETAIL_KEYS.WIDGET_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${DETAIL_KEYS.DELETE}`,
        ];
        descriptionText += details.join("\n");
        break;
      }
      case "Dashboard_update": {
        let details = [
          `${DETAIL_KEYS.DASHBAORD_ID}: ${result.item_id}`,
          `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
          `${DETAIL_KEYS.EVENT}: ${result.event}`,
        ];
        if (result.object_changes?.name?.length === 2) {
          details.push(`${DETAIL_KEYS.NAME}:`,
          `\t${DETAIL_KEYS.OLD_VAL}: ${result.object_changes.name[0]}`,
          `\t${DETAIL_KEYS.NEW_VAL}: ${result.object_changes.name[1]}`)
        }
        if (result.object_changes?.settings?.length === 2) {
          details.push(`${DETAIL_KEYS.SETTINGS}:`,
          `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.parsed_object_settings, null, '\t')}`,
          `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.parsed_changes_settings, null, '\t')}`)
        }
        if (result.object_changes?.custom_settings?.length === 2) {
          details.push(`${DETAIL_KEYS.CUSTOM_SETTING}:`,
          `\t${DETAIL_KEYS.OLD_VAL}: ${JSON.stringify(result.parsed_object_custom_settings, null, '\t')}`,
          `\t${DETAIL_KEYS.NEW_VAL}: ${JSON.stringify(result.parsed_changes_custom_settings, null, '\t')}`)
        }

        descriptionText += details.join("\n");
        break;
      }
      default:
        descriptionText += `Item Type: ${result.item_type || "N/A"}\n`;
        descriptionText += `Event: ${result.event || "N/A"}\n`;
    }

    return (
      <Editor StringData={descriptionText} FormateType="json" />
    );
  }
}